import { render, staticRenderFns } from "./cloudfileLeft.vue?vue&type=template&id=3adfccf8&scoped=true"
import script from "./cloudfileLeft.vue?vue&type=script&lang=js"
export * from "./cloudfileLeft.vue?vue&type=script&lang=js"
import style0 from "./cloudfileLeft.vue?vue&type=style&index=0&id=3adfccf8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3adfccf8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3adfccf8')) {
      api.createRecord('3adfccf8', component.options)
    } else {
      api.reload('3adfccf8', component.options)
    }
    module.hot.accept("./cloudfileLeft.vue?vue&type=template&id=3adfccf8&scoped=true", function () {
      api.rerender('3adfccf8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/cloudfile/components/layout/cloudfileLeft.vue"
export default component.exports